export default {
  appEntityPathRegex: /^\/(jobs|leads|persons|schedules|sources)\/.*/i,
  appPathRegex:
    /^\/?(access-denied|help|jobs|leads|persons|sandbox|schedules|sources).*/i,
  entityRegex: /^\/?(person|job|lead|schedule|source).*/i,
  errorPathRegex: /^\/?(access-denied|maintenance|not-found|unauthorized).*/i
}
